import { useTranslation } from 'react-i18next';
import UPInput from 'components/input';
import { COMPANY_INTEGRATION__API_KEY, COMPANY_INTEGRATION__ENVIRONMENT_KEY } from 'translations/constants';
import { RowContainer } from '../styles';
import { StrobboIntegrationProps } from './types';

const StrobboIntegration = (props: StrobboIntegrationProps): JSX.Element => {
  const { environmentKey, externalApiAccessKey, setEnvironmentKey, setExternalApiAccessKey } = props;
  const [t] = useTranslation();

  return (
    <>
      <RowContainer>
        <UPInput
          value={environmentKey}
          label={t(COMPANY_INTEGRATION__ENVIRONMENT_KEY)}
          placeholder={t(COMPANY_INTEGRATION__ENVIRONMENT_KEY)}
          helperText=""
          onChange={e => setEnvironmentKey(e.target.value)}
        />
      </RowContainer>
      <RowContainer>
        <UPInput
          value={externalApiAccessKey}
          label={t(COMPANY_INTEGRATION__API_KEY)}
          placeholder={t(COMPANY_INTEGRATION__API_KEY)}
          helperText=""
          onChange={e => setExternalApiAccessKey(e.target.value)}
        />
      </RowContainer>
    </>
  );
};

export default StrobboIntegration;
